/* eslint-disable no-unused-vars */
import React, { useState, CSSProperties } from "react";
import { useCSVReader } from "react-papaparse";
import SendToDbButton from "../SendToDbButton/SendToDbButton";
import { processCollarCsv } from "../../utils/utils";
import type { Collar, CollarData } from "../../types/apiTypes";
import CollarTable from "../CollarTable/CollarTable";
import { updateCollars } from "../../utils/apiCalls";

const styles = {
  csvReader: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
  } as CSSProperties,
  browseFile: {
    width: "20%",
  } as CSSProperties,
  acceptedFile: {
    border: "1px solid #ccc",
    height: 45,
    lineHeight: 2.5,
    paddingLeft: 10,
    width: "80%",
  } as CSSProperties,
  remove: {
    borderRadius: 0,
    padding: "0 20px",
  } as CSSProperties,
  progressBarBackgroundColor: {
    backgroundColor: "red",
  } as CSSProperties,
};

const AddCollars = () => {
  const [csvData, setCsvData] = useState<CollarData[]>();
  const { CSVReader } = useCSVReader();

  const handleFileUpload = (data: any) => {
    const processedCollarData = processCollarCsv(data.data);
    setCsvData(processedCollarData);
  };

  const sendToDb = (data: CollarData[]) => {
    return updateCollars(data);
  };

  return (
    <div>
      <CSVReader
        onUploadAccepted={(results: any) => {
          handleFileUpload(results);
        }}
        onDrop={(results: any) => {
          handleFileUpload(results);
        }}
        config={{ header: true }}
      >
        {({
          getRootProps,
          acceptedFile,
          ProgressBar,
          getRemoveFileProps,
        }: any) => {
          return (
            <>
              <div style={styles.csvReader}>
                <button
                  type="button"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...getRootProps()}
                  style={styles.browseFile}
                >
                  Browse file
                </button>
                <div style={styles.acceptedFile}>
                  {acceptedFile && acceptedFile.name}
                </div>
                <button
                  type="button"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...getRemoveFileProps()}
                  style={styles.remove}
                >
                  Remove
                </button>
              </div>
              <ProgressBar style={styles.progressBarBackgroundColor} />
            </>
          );
        }}
      </CSVReader>
      <div>
        {csvData !== undefined && (
          <div>
            <SendToDbButton
              data={csvData}
              f={sendToDb}
              endpoint="api/collars/new"
              successMessage="Added shafts!"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AddCollars;
